import { render, staticRenderFns } from "./Wxlogin.vue?vue&type=template&id=5e871eb2&scoped=true&"
import script from "./Wxlogin.vue?vue&type=script&lang=js&"
export * from "./Wxlogin.vue?vue&type=script&lang=js&"
import style0 from "./Wxlogin.vue?vue&type=style&index=0&id=5e871eb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e871eb2",
  null
  
)

export default component.exports